import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<header><div class=\"row\"><div class=\"col-sm-6\"><h1>Preferred clients</h1></div><div class=\"col-sm-6 text-right\"><button class=\"btn btn-outline-primary\" data-toggle=\"modal\" data-target=\"#add-preferredclient-modal\"><i class=\"fas fa-plus\"></i></button></div></div></header>", 1)
const _hoisted_2 = {
  key: 0,
  class: "alert alert-warning text-center"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "mt-1 mb-2" }, "No preferred clients found", -1)
const _hoisted_4 = { class: "mb-1" }
const _hoisted_5 = {
  key: 1,
  class: "table table-fixed"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "align-middle" }, "Company"),
    /*#__PURE__*/_createElementVNode("th", { class: "align-middle" }, "Branch"),
    /*#__PURE__*/_createElementVNode("th", { class: "align-middle" }, "Region"),
    /*#__PURE__*/_createElementVNode("th")
  ])
], -1)
const _hoisted_7 = { class: "text-right" }
const _hoisted_8 = { class: "list-unstyled mb-0" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt" }, null, -1)
const _hoisted_11 = [
  _hoisted_10
]

import { ref, computed } from 'vue';
import { useStore } from 'vuex';
import AddPreferredClientModal from '@/components/modals/AddPreferredClientModal.vue';
import { Inspector, Office, Customer } from "@/models";


export default /*#__PURE__*/_defineComponent({
  __name: 'PreferredClients',
  setup(__props) {

const hasBlockingRequests = computed(() => store.getters['app/hasBlockingRequests']);
const inspector = computed(() => store.getters['inspectors/current']);
const offices = computed(() => store.getters['offices/getOffices']);

const removePreferredClient = (client: Customer) => store.dispatch("inspectors/removePreferredClient", client);
const remove = (customer: Customer) => {
  removePreferredClient(customer);
}


const store = useStore();


// Create a function to get the region by ID
const getRegion = (id: string) => {
  const office = offices.value.find((o: Office) => o.id === id);
  return office ? office.name : '';
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    (!inspector.value.preferredclients.length && !hasBlockingRequests.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("p", _hoisted_4, "for " + _toDisplayString(inspector.value.name) + ", please add", 1)
        ]))
      : (_openBlock(), _createElementBlock("table", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(inspector.value.preferredclients, (customer, $customerindex) => {
              return (_openBlock(), _createElementBlock("tr", { key: $customerindex }, [
                _createElementVNode("td", null, _toDisplayString(customer.companyName), 1),
                _createElementVNode("td", null, _toDisplayString(customer.branchName), 1),
                _createElementVNode("td", null, _toDisplayString(getRegion(customer.office)), 1),
                _createElementVNode("td", _hoisted_7, [
                  _createElementVNode("ul", _hoisted_8, [
                    _createElementVNode("li", {
                      class: "list-item",
                      onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                    }, [
                      _createElementVNode("button", {
                        class: "btn btn-outline-danger",
                        onClick: ($event: any) => (remove(customer))
                      }, _hoisted_11, 8, _hoisted_9)
                    ])
                  ])
                ])
              ]))
            }), 128))
          ])
        ])),
    _createVNode(AddPreferredClientModal)
  ]))
}
}

})